module.exports = __webpack_public_path__ + "img/4.e4d31d8c.png";